module.exports = __webpack_public_path__ + "prod/1.42.2/img/service-center.b717ccab.png";